import { render, staticRenderFns } from "./xiaoqu.vue?vue&type=template&id=a09e7864&scoped=true&"
import script from "./xiaoqu.vue?vue&type=script&lang=js&"
export * from "./xiaoqu.vue?vue&type=script&lang=js&"
import style0 from "./xiaoqu.vue?vue&type=style&index=0&id=a09e7864&prod&lang=css&"
import style1 from "./xiaoqu.vue?vue&type=style&index=1&id=a09e7864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e7864",
  null
  
)

export default component.exports